import { Slider, SliderRange, SliderThumb, SliderTrack } from "@radix-ui/react-slider"

import { cn } from "@/domains/library"

export interface ChunkSizeSliderViewProps {
  min: number
  max: number
  value: number
  onChange: (value: number) => void
  disabled?: boolean
}

/**
 * Compact slider component for adjusting chunk size in diagnostics table
 */
export const ChunkSizeSliderView = ({ min, max, value, onChange, disabled = false }: ChunkSizeSliderViewProps) => {
  return (
    <div className="w-full min-w-[120px]">
      <Slider
        className="slider-root group relative flex h-[24px] min-h-[24px] w-full touch-none select-none items-center"
        defaultValue={[value]}
        disabled={disabled}
        max={max}
        min={min}
        step={1}
        value={[value]}
        onValueChange={(values: number[]) => {
          onChange(values[0] ?? min)
        }}
      >
        <SliderTrack className="slider-track relative h-[6px] flex-grow rounded-full bg-p400">
          <SliderRange className="slider-range absolute inset-0 h-full rounded-full bg-p100" />
        </SliderTrack>
        <SliderThumb
          className={cn(
            "slider-thumb text-t200 hover:bg-p100",
            "bg-p100",
            "border border-p400",
            "relative flex h-[20px] w-[20px] flex-col items-center justify-center",
            "rounded-full",
            "text-center text-[9px]",
            "font-normal",
            "shadow-md",
            "focus:outline-none",
            "focus:ring-2 focus:ring-ring focus:ring-offset-0",
          )}
        >
          {value}
        </SliderThumb>
      </Slider>
    </div>
  )
}
